import { Cor, DadoPesquisaCor, FiltroPesquisaCor } from "app/api/classes/ProdutoApi";
import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useState } from "react";
import { PaginaPesquisaProdutoContainer, PesquisaProdutoPagina } from "../PaginaPesquisaProdutoContainer";
import { PesquisaCor } from "./PesquisaCor";
import { IProduto } from "app/types/produto/IProduto";
import { CorTintaSelecionada } from "./cor-selecionada/CorTintaSelecionada";
import { ItensOrcamentoContainer } from "app/components/itens-orcamento/ItensOrcamentoContainer";
import { removerBreadcrumb2 } from "app/components/breadcrumb2/breadcrumb2Utils";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { PesquisaCorTinta } from "./PesquisaCorTinta";


export type PesquisaCorTintaContainerProps = {
  identificadorItem: number
  codigoProduto: string // codigo produto tintomentrico - produto final tinta
  codigoCorSelecionada: number // codigo da cor que ja foi selecionada
  onVoltar: () => void,
  onRetornarCorSelecionada: (CorTintaSelecionada: number, identificadorItem: number) => void,
}


export const PesquisaCorTintaContainer = (props: PesquisaCorTintaContainerProps) => {

  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [dadosPesquisaCor, setDadosPesquisaCor] = useState<DadoPesquisaCor>();
  //const [itemSelecionado, setItemSelecionado] = useState<IProduto>(props.item);
  const [filtros, setFiltros] = useState<FiltroPesquisaCor>({
    CodigoCorFabricante: null,
    CodigoProduto: props.codigoProduto,
    DescricaoCor: null,
    NumeroPagina: 1,
    TamanhoPagina: 20,
  });

  const onPesquisarCorTinta = async (filtroPesquisa: FiltroPesquisaCor) => {

    try {
      globalMU.blockUI();
      setFiltros(filtroPesquisa);
      const dadosCores = await microuniversoApi.Produto.pesquisaCor(filtroPesquisa);

      setDadosPesquisaCor(dadosCores);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const pesquisaPaginada = async (numeroIndexPagina: number) => {
    globalMU.blockUI();
    try {
      const filtrosAlterado = { ...filtros, NumeroPagina: numeroIndexPagina };
      setFiltros(filtros);
      const dadosCores = await microuniversoApi.Produto.pesquisaCor(filtrosAlterado);
      setDadosPesquisaCor(dadosCores);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  return (
    <>
      <Breadcrumb2Container
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="PesquisaCorTintaContainer"
        onBotaoVoltarClicado={() => props.onVoltar()}
        onPassoSelecionado={(passo) => {
          if (passo == "Itens") {
            removerBreadcrumb2()
            renderizarComponentReact(
              < ItensOrcamentoContainer />,
              "conteudo-pagina",
              true
            )
          }

          if (passo == "Pesquisar Produtos") {
            props.onVoltar()
          }
        }}
        passos={["Itens", "Pesquisar Produtos", "Selecionar Cor"]}
      />

      <PesquisaCorTinta
        tintometricoSimplificado={true}
        filtro={filtros}
        cores={dadosPesquisaCor}
        corFundoSelecionado={globalMU.sessionStorage.getData("UsuarioLogado")?.CorFundo}
        corTextoSelecionado={globalMU.sessionStorage.getData("UsuarioLogado")?.CorTexto}
        onPesquisar={onPesquisarCorTinta}
        onAlterarListaSelecionada={(numeroPagina) => pesquisaPaginada(numeroPagina)}
        onClickSelecionado={async (cor) => {
          props.onRetornarCorSelecionada(+cor.Codigo, props.identificadorItem)
        }} />

    </>
  );
};
